const pt = {
	Credentials: "Credenciales",
	Logout: "Cerrar la sesión",
	"My Credentials": "Mis credenciales",
	"Issue Date": "Fecha de emisión",
	By: "Por",
	View: "Ver",
	Verify: "Verificar",
	purchase_for: "Comprar por",
	"Terms of Service": "Condiciones del servicio",
	"Privacy & Data Protection": "Privacidad y protección de datos",
	"Customer Support": "Atención al cliente",
	"Help Center": "Centro de ayuda",
	"Verify Certificate": "VVerificar el certificado",
	"View Certificate": "Ver certificado",
	Inbox: "Bandeja de entrada",
	//to do
	"Open Issuers App": "Emittenten-App",
	Name: "Name",
	"You are purchasing": "Sie kaufen",
	"Payment info": "Zahlungsinformationen",
	Email: "Email",
};
export default pt;
